module.exports = __webpack_public_path__ + "img/index13.6a95de0b.png";